import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Sparkles, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCatalogNews = (enabled) => {
  const [newIds, setNewIds] = useState(new Set());
  const token = localStorage.getItem('subscriberToken');

  useEffect(() => {
    if (!enabled || !token) return;
    axios.get(`${API}/digital/novidades?auth=${token}`)
      .then(({ data }) => setNewIds(new Set(data.book_ids)))
      .catch(() => setNewIds(new Set()));
  }, [enabled, token]);

  const markSeen = useCallback(async () => {
    setNewIds(new Set());
    if (token) await axios.post(`${API}/digital/novidades/seen?auth=${token}`).catch(() => {});
  }, [token]);

  return { newIds, markSeen };
};

export const NewBadge = ({ color }) => (
  <span data-testid="book-new-badge" style={{
    position: 'absolute', top: 8, left: 8, zIndex: 2, padding: '0.15rem 0.55rem', borderRadius: 999,
    background: color || '#51cc23', color: 'white', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.04em',
    textTransform: 'uppercase', boxShadow: '0 2px 6px rgba(0,0,0,0.2)', pointerEvents: 'none'
  }}>Novo</span>
);

export const CatalogNewsBanner = ({ count, onlyNew, onToggleOnlyNew, onMarkSeen, color }) => {
  if (!count) return null;
  return (
    <div data-testid="catalog-news-banner" className="catalog-block-gap" style={{
      display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap', padding: '0.85rem 1.1rem',
      borderRadius: 12, background: '#FFF8D6', border: `1px solid ${color}55`, borderLeft: `4px solid ${color}`,
      boxShadow: '0 2px 10px rgba(0,0,0,0.05)', animation: 'fadeIn 0.3s ease-out'
    }}>
      <Sparkles className="w-5 h-5" style={{ color, flexShrink: 0 }} />
      <p data-testid="catalog-news-text" style={{ flex: 1, minWidth: 200, margin: 0, color: '#2D3748', fontWeight: 600 }}>
        {count === 1 ? '1 livro novo' : `${count} livros novos`} desde a sua última visita
      </p>
      <button type="button" onClick={onToggleOnlyNew} data-testid="catalog-news-toggle"
        style={{ padding: '0.45rem 0.9rem', borderRadius: 999, border: `1px solid ${color}`, background: onlyNew ? color : 'transparent', color: onlyNew ? 'white' : color, fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', transition: 'background-color 0.2s ease' }}>
        {onlyNew ? 'Ver todos' : 'Ver novidades'}
      </button>
      <button type="button" onClick={onMarkSeen} data-testid="catalog-news-seen"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', padding: '0.45rem 0.9rem', borderRadius: 999, border: 'none', background: '#f1f5f9', color: '#475569', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer' }}>
        <Check className="w-4 h-4" /> Marcar como visto
      </button>
    </div>
  );
};
